"use strict";import{tag as a}from"../custom-tag.js";export function updateIcon({height:t=16,width:e=16,hidden:l=!1,title:r="Update"}={}){return a`
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width=${e}
      height=${t}
      fill="currentColor"
      viewBox="0 0 24 24"
      aria-hidden="${l?"true":"false"}"
      role="img"
      aria-label="${r}"
    >
      <path
        fill="currentColor"
        d="M6.632 20.095q3.037 2.549 6.907 2.216 3.87-.331 6.419-3.369a9.25 9.25 0 0 0 1.808-3.307 9.6 9.6 0 0 0 .385-3.603 9.5 9.5 0 0 0-.995-3.483q-.843-1.674-2.362-2.948a9.2 9.2 0 0 0-3.314-1.805 9.6 9.6 0 0 0-3.607-.38 9.4 9.4 0 0 0-3.468 1 9.2 9.2 0 0 0-2.92 2.339l-.235.28-.188-2.147-1.628.152.443 5.172 5.17-.463-.133-1.63-2.147.189.244-.291q1.972-2.35 5.077-2.592t5.429 1.708q2.356 1.977 2.628 5.068.27 3.091-1.712 5.455-1.962 2.36-5.063 2.633-3.101.271-5.465-1.712a7.3 7.3 0 0 1-1.765-2.2 7.2 7.2 0 0 1-.82-2.763l-2.001.185a9.2 9.2 0 0 0 1.02 3.431 9.3 9.3 0 0 0 2.293 2.865"
      />
    </svg>
  `}
//# sourceMappingURL=update.js.map
